module.exports = __webpack_public_path__ + "img/中繼站1_計算成績.854d16fc.png";